import { dayjs } from '@2wunder/klarx-tool'
import { Col, Row } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import Timeline from 'app/components/Modules/Timeline/Timeline'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import SchedulerGroup from './Group'
import Item from './Item'

export type ISchedulerLineItem = Omit<ILineItem, 'start_time'>

type Props = {
  filters?: React.ReactNode
}

const Scheduler: React.FC<CollectionProps<ILineItem, Props>> = ({
  collection: lineItems,
  props
}) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  const items = lineItems.map((item) => ({
    ...item,
    group: item.id,
    end_time: dayjs(item.return_date).parseLocaleDate().endOf('day').valueOf(),
    start_time: dayjs(item.start_date).parseLocaleDate().valueOf()
  }))

  const groups = lineItems.map((group) => ({ ...group, title: group.name, height: 57 }))

  const handleItemClick = (item: ILineItem): void => {
    navigate(Routes.Rental.member(item.rentalId.toString()).show)
  }

  return (
    <Row className="line-item-scheduler-container">
      <Col span={24}>
        <Timeline<ISchedulerLineItem, ILineItem>
          items={items}
          groups={groups}
          sidebarHeader={
            <span className="text-primary ml-2 my-auto">
              {formatMessage({ id: 'line_item.scheduler.header.machine' })}
            </span>
          }
          itemRenderer={(props) => <Item {...props} onClick={handleItemClick} />}
          groupRenderer={(props) => <SchedulerGroup {...props} onClick={handleItemClick} />}
          {...props}
        />
      </Col>
    </Row>
  )
}

export default Scheduler
